module.exports = __webpack_public_path__ + "static/media/pdf-icon.42225524.svg";